import { userHasRole, userHasPermission } from "@accredo/fe-shared/utils/policyUtils.js";

export default {
  viewAny: ({ user }) => {
    return userHasRole(user, ["sysadmin", "accredo_buchungsexport"]);
  },
  exportAny: ({ user }) => {
    return (
      userHasRole(user, ["sysadmin", "accredo_buchungsexport"]) &&
      userHasPermission(user, "buchung_export")
    );
  },
};
